import type { FeeSchedulingMethodRef } from '../services/productFees';

export const DEFAULT_FEE_SCHEDULING_TYPE_KEY = 'service_plan';

export const schedulingMethodsForType = (
    methods: readonly FeeSchedulingMethodRef[],
    productTypeKey: string | null,
): FeeSchedulingMethodRef[] => {
    const key = productTypeKey ?? DEFAULT_FEE_SCHEDULING_TYPE_KEY;
    return methods.filter((method) => method.product_type_keys.includes(key));
};

export const isSchedulingAllowed = (
    methodId: string,
    methods: readonly FeeSchedulingMethodRef[],
    productTypeKey: string | null,
): boolean => schedulingMethodsForType(methods, productTypeKey).some((method) => method.id === methodId);
